import { Know } from 'interfaces/Know'
import { AnalyticsEventKnowPageSessionDuration } from 'lib/constants/AnalyticsEventType'
import { trackEvent } from 'lib/tracking/analytics-service'

import React, { useEffect } from 'react'

interface Props {
    know: Know | null
}

const KnowPageSessionDurationTracking = ({ know }: Props) => {
    const SESSION_TRACKING_INTERVAL = 5000

    useEffect(() => {
        if (!know) return

        let sessionDuration = 0

        const interval = setInterval(() => {
            sessionDuration += SESSION_TRACKING_INTERVAL / 1000
            trackEvent(AnalyticsEventKnowPageSessionDuration, {
                value: know.uuid,
                valueId: sessionDuration,
                know,
            })
        }, SESSION_TRACKING_INTERVAL)

        return () => {
            clearInterval(interval)
        }
    }, [know])

    return <></>
}

export default KnowPageSessionDurationTracking
